import React, { useEffect, useState } from "react";
import { Card, Col, Input, Row, Dropdown, DropdownToggle, DropdownMenu, FormGroup, Label } from "reactstrap";
import ReactTable from "react-table";
import GetSettingWorkflowTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/GetSettingWorkflowTaskService";
import UpdateTaskActiveStatusService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskActiveStatusService";
import UpdateTaskRolesForTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskRolesForTaskService";
import WorkflowsOpenDrawerIcon from "../../../../../../../designUtils/Workflows/WorkflowsOpenDrawerIcon.svg";
import WorkflowsCloseDrawerIcon from "../../../../../../../designUtils/Workflows/WorkflowsCloseDrawerIcon.svg";
import notify from '../../../../../../../Notifications/ToastifyActions'

function WorkflowUpdatedPhaseSettings(props) {
  const [activeMasterPhase, setActiveMasterPhase] = useState(null);
  const [activeSubPhaseId, setActiveSubPhaseId] = useState(null);
  const [taskList, setTaskList] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [changedRoles, setChangedRoles] = useState({});
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [roleDropdownOpen, setRoleDropdownOpen] = useState({}); 
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [expandedPhases, setExpandedPhases] = useState({});

  useEffect(() => {
    setLoading(true);
    const data = { settingsWorkflowId: props.settingsWorkflowId };
    
    GetSettingWorkflowTaskService(props.token, data).then((res) => {
      if (res) {
        setTaskList(res.tasklist || []);
        setAllTasks(res.tasklist || []);
        setRolesList(res.rolesList || []);
        setLoading(false);
      }
    });
  }, [props.settingsWorkflowId, props.token]);

  const togglePhase = (phaseId) => {
    setExpandedPhases(prev => ({
      ...prev,
      [phaseId]: !prev[phaseId]
    }));
  };

  const masterPhasesMap = {};
  const sortedSubPhases = [...(props.workflowPhases || [])].sort((a, b) => {
    const getMasterId = (p) => Number(p.MasterPhase || p.masterPhase || p.MasterPhase_id || p.masterPhase_id || 0);
    const masterA = getMasterId(a);
    const masterB = getMasterId(b);

    if (masterA === masterB) {
      return Number(a.id) - Number(b.id); 
    }
    return masterA - masterB; 
  });

  sortedSubPhases.forEach((phase) => {
    const masterId = phase.MasterPhase || phase.masterPhase || phase.MasterPhase_id || phase.masterPhase_id || 'null_phase';
    if (!masterPhasesMap[masterId]) {
      masterPhasesMap[masterId] = [];
    }
    masterPhasesMap[masterId].push(phase);
  });

  let masterPhaseTabs = (props.workflowMasterPhases || [])
    .filter((mp) => Number(mp.WorkflowsMaster) === Number(props.settingsWorkflowId))
    .sort((a, b) => Number(a.id) - Number(b.id));

  if (masterPhaseTabs.length === 0) {
    masterPhaseTabs = Object.keys(masterPhasesMap)
      .filter(id => id !== 'null_phase')
      .map(id => {
        const actualMaster = (props.workflowMasterPhases || []).find(mp => Number(mp.id) === Number(id));
        const realName = actualMaster ? (actualMaster.name || actualMaster.phase || actualMaster.masterPhase) : `PHASE ${id}`;
        return { id: id, phase: realName || `PHASE ${id}` };
      })
      .sort((a, b) => Number(a.id) - Number(b.id));
  }

  const currentMasterPhase = (activeMasterPhase !== null)
    ? String(activeMasterPhase)
    : (masterPhaseTabs.length > 0 ? String(masterPhaseTabs[0].id) : null);

  const subPhasesList = masterPhaseTabs.length > 0 
    ? (masterPhasesMap[currentMasterPhase] || []) 
    : sortedSubPhases;

  const defaultSubPhaseId = (subPhasesList && subPhasesList.length > 0) ? subPhasesList[0].id : null;
  const currentSubPhaseId = activeSubPhaseId || defaultSubPhaseId;

  const handleMasterPhaseClick = (masterId) => {
    const strMasterId = String(masterId); 
    setActiveMasterPhase(strMasterId);
    
    if (masterPhasesMap[strMasterId] && masterPhasesMap[strMasterId].length > 0) {
      setActiveSubPhaseId(masterPhasesMap[strMasterId][0].id);
    } else {
      setActiveSubPhaseId(null);
    }
  };

  const handlePreviewToggle = () => setIsPreviewMode((prev) => !prev);
  
  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (value && !isPreviewMode) {
      const searchTerm = value.trim().toLowerCase();
      
      const firstMatch = allTasks.find((task) =>
        (task.taskText || "").toLowerCase().includes(searchTerm)
      );

      if (firstMatch) {
        const matchedSubPhaseId = Number(firstMatch.WorkflowPhases || firstMatch.workflowPhases || firstMatch.phaseId);

        let matchedMasterId = null;
        for (const [masterId, subPhases] of Object.entries(masterPhasesMap)) {
          if (subPhases.some((sp) => Number(sp.id) === matchedSubPhaseId)) {
            matchedMasterId = masterId;
            break;
          }
        }

        if (matchedMasterId) {
          setActiveMasterPhase(String(matchedMasterId));
        }
        if (matchedSubPhaseId) {
          setActiveSubPhaseId(matchedSubPhaseId);
        }
        setIsDrawerOpen(true);
      }
    }
  };

  const getFilteredTasks = () => {
    return allTasks.filter((task) => {
      const searchMatch = (task.taskText || "").toLowerCase().includes(searchInput.toLowerCase());
      const phaseMatch = isPreviewMode || Number(task.WorkflowPhases) === Number(currentSubPhaseId);
      return searchMatch && phaseMatch;
    });
  };

  const toggleRoleDropdown = (taskId) => {
    setRoleDropdownOpen((prev) => ({
        ...prev,
        [taskId]: !prev[taskId]
    }));
  };

  const getCurrentSelectedRoles = (task) => {
      if (changedRoles[task.id] !== undefined) {
          return Array.isArray(changedRoles[task.id]) ? changedRoles[task.id] : [changedRoles[task.id]];
      }
      if (task && task.roleId) {
          return String(task.roleId).split(',').map(id => id.trim());
      }
      return [];
  };

  const handleRoleCheckboxChange = (taskId, roleId, task) => {
    const currentRoles = getCurrentSelectedRoles(task);
    let updatedRoles = [...currentRoles];
    const stringRoleId = String(roleId);

    if (updatedRoles.includes(stringRoleId)) {
        updatedRoles = updatedRoles.filter(id => id !== stringRoleId);
    } else {
        updatedRoles.push(stringRoleId);
    }

    setChangedRoles((prev) => ({
        ...prev,
        [taskId]: updatedRoles
    }));

    const filteredRoles = updatedRoles.filter(
      role => role !== "None" && role !== null && role !== undefined
  );

    let data = {
        taskId: taskId,
        roleId: filteredRoles,
        settingsWorkflowId: props.settingsWorkflowId
    };

    UpdateTaskRolesForTaskService(props.token, data).then((res) => {
        if (res && res.res) {
            setTaskList(res.res.tasklist || []);
            setAllTasks(res.res.tasklist || []);
            setRolesList(res.res.rolesList || []);
            if (filteredRoles.length > 1) {
              notify.NotifySuccess('New Role assignements have been updated successfully. Please update new assignements manually for all the stores for new assignees.')}
        }
    });
  };

  const getSelectedRoleNames = (task) => {
    const selectedIds = getCurrentSelectedRoles(task);
    if (selectedIds.length === 0) return "--Select Role--";

    const roleNames = rolesList
        .filter(role => selectedIds.includes(String(role.id)))
        .map(role => role.role)
        .join(", ");

    return roleNames ? roleNames : "--Select Role--";
  };

  const handleActiveChange = (task) => {
    const newStatus = !task.isActive;
    const updated = allTasks.map((t) => t.id === task.id ? { ...t, isActive: newStatus } : t);
    setAllTasks(updated);

    UpdateTaskActiveStatusService(props.token, {
      taskId: task.id,
      isActive: newStatus,
    }).then((res) => {
      console.log("Updated successfully", res);
    });
  };

  const filteredTasks = getFilteredTasks();

  const gridColumns = [
    {
      Header: "Task",
      accessor: "taskText",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100 ">
          <p className="m-0 comment-paragraph-ticket-history" title={cellInfo.value} style={{ whiteSpace: "normal" }}>
            {cellInfo.value}
          </p>
        </div>
      ),
    },
    {
      Header: "Role",
      accessor: "roleId",
      Cell: (cellInfo) => {
        const task = cellInfo.original;
        const selectedNames = getSelectedRoleNames(task);
        
        if (isPreviewMode) {
          return (
            <div className="d-flex align-items-start w-100">
              <p className="mb-0" style={{ whiteSpace: "normal", color: "#495057" }}>
                 {selectedNames !== "--Select Role--" ? selectedNames : ""}
              </p>
            </div>
          );
        }

        return (
          <div className="d-flex flex-column align-items-center w-100"> 
            <Dropdown 
                isOpen={roleDropdownOpen[task.id] || false} 
                toggle={() => toggleRoleDropdown(task.id)} 
                className="w-100"
            >
                <DropdownToggle 
                    caret 
                    className="form-control d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                        {selectedNames}
                    </span>
                </DropdownToggle>
                <DropdownMenu 
                    positionFixed={true} 
                    container="body"
                    style={{ 
                        width: '250px', 
                        maxHeight: '200px', 
                        overflowY: 'auto',
                        padding: '10px' 
                    }}
                >
                    {rolesList.map((role) => (
                        <FormGroup check key={role.id} className="m-2">
                            <Label check style={{ cursor: 'pointer', width: '100%' }}>
                                <Input 
                                    type="checkbox" 
                                    checked={getCurrentSelectedRoles(task).includes(String(role.id))}
                                    onChange={() => handleRoleCheckboxChange(task.id, role.id, task)}
                                />
                                {role.role}
                            </Label>
                        </FormGroup>
                    ))}
                </DropdownMenu>
            </Dropdown>
            
            {selectedNames !== "--Select Role--" && (
              <div className="w-100 mt-1 marquee-container" style={{ padding: "4px 0" }}>
                <div className="marquee-text" style={{ color: "black", fontSize: "13px" }}>
                  {selectedNames}
                </div>
              </div>
            )}
          </div>
        );
      }
    },
    {
      Header: "Active",
      accessor: "isActive",
      width: 150,
      Cell: (cellInfo) => {
        const task = cellInfo.original;
        return (
          <div className="d-flex justify-content-center w-100 pt-1">
            <input
              type="checkbox"
              checked={task.isActive || false}
              onChange={() => handleActiveChange(task)}
              disabled={isPreviewMode} 
              style={{ cursor: isPreviewMode ? "not-allowed" : "pointer", width: "16px", height: "16px" }}
            />
          </div>
        );
      }
    }
  ];

  const renderPreviewSubPhases = (masterKey) => {
    const subPhases = masterPhasesMap[masterKey];
    if (!subPhases) return null;

    return subPhases.map((wp) => {
      const phaseTasks = filteredTasks.filter(
        (task) => Number(task.WorkflowPhases) === Number(wp.id)
      );

      if (phaseTasks.length === 0) return null;

      const isSearchActive = searchInput.trim() !== "";
      const isOpen = expandedPhases[wp.id] || isSearchActive || false; 

      return (
        <div key={wp.id} className="mb-3">
        <div
          onClick={() => togglePhase(wp.id)}
          className={`workflow-phase-header ${isOpen ? 'is-open' : ''}`}
        >
          <h6 className="m-0 workflow-phase-title"><b>{wp.name}</b></h6>
          <span className={`workflow-phase-arrow ${isOpen ? 'is-open' : ''}`}>
            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 10.5V1.5C0 0.833333 0.7698 0.45523 1.3 0.85L9.1 5.35C9.56667 5.61667 9.56667 6.38333 9.1 6.65L1.3 11.15C0.7698 11.5448 0 11.1667 0 10.5Z" fill="#000000"/>
            </svg>
          </span>
        </div>

          {isOpen && (
            <ReactTable
              data={phaseTasks}
              columns={gridColumns}
              className="-striped -highlight mt-2"
              getTheadProps={() => {
                return {
                  style: { overflowY: "hidden", background: "#B1FA63", color: "#243837" },
                };
              }}
              defaultPageSize={5}
              showPagination={true}
              noDataText={"No Tasks Found."}
            />
          )}
        </div>
      );
    });
  };

  return (
    <>
      <Card className="pr-3 pl-3 pt-3 pb-3 mt-3 card-of-problemarea">
        <Row className="align-items-center mx-0 mb-3">
        <Col md={12} className="p-0">
            <div className="d-flex justify-content-between align-items-center w-100">
              
              <div>
                {props.workflowDropdown} 
              </div>

              <div className="d-flex align-items-center">
                
                <div className="d-flex align-items-center mr-4">
                  <label className="worflows-setting-toggle-switch mb-0 mr-2">
                    <input
                      type="checkbox"
                      className="d-none"
                      checked={isPreviewMode}
                      onChange={handlePreviewToggle}
                    />
                    <span className="worflows-setting-dot"></span>
                  </label>
                  <span className="mt-1 mb-2" style={{ whiteSpace: "nowrap" }}>Preview All Tasks</span>
                </div>

                <div style={{ width: "300px" }}>
                  <Input
                    type="text"
                    value={searchInput}
                    disabled={loading}
                    onChange={handleSearchInputChange}
                    className="form-control"
                    placeholder="Search Tasks"
                  />
                </div>

              </div>
              
            </div>
          </Col>
        </Row>
        {!isPreviewMode && masterPhaseTabs.length > 0 && (
          <Row className="mb-2 mx-0 pt-2 border-bottom">
            <Col md={12} className="d-flex flex-wrap align-items-center justify-content-around p-0">
              {masterPhaseTabs.map((masterTab) => {
                const masterId = String(masterTab.id);
                const isActive = currentMasterPhase === masterId;
                const rawName = masterTab.name || masterTab.phase || masterTab.masterPhase || masterTab.phaseName || `PHASE ${masterId}`;
                const displayPhaseName = String(rawName).toUpperCase();

                return (
                  <div
                    key={masterId}
                    onClick={() => handleMasterPhaseClick(masterId)}
                    style={{ cursor: "pointer" }}
                    className={isActive ? "selected-tab-workflows m-2" : "pt-3 pb-3 m-2"}
                  >
                    <p className="text-center p-0 mb-0" style={{ fontSize: "15px" }}>
                      <b>{displayPhaseName}</b>
                    </p>
                  </div>
                );
              })}
            </Col>
          </Row>
        )}

        {!isPreviewMode ? (
          <div className="d-flex w-100 mt-3 position-relative align-items-start px-2">
            
            {isDrawerOpen ? (
              <div className="workflow-sidebar position-relative pr-2" style={{ flex: "0 0 340px", width: "340px", minHeight: "400px" }}>     
                <div className="workflow-subphase-list pb-5">
                  {subPhasesList.map((subPhase, index) => {
                    const isActiveSub = currentSubPhaseId === subPhase.id;
                    const idxStr = String(index + 1).padStart(2, '0');
                    let iconStatusClass = isActiveSub ? 'active' : 'pending';

                    return (
                      <div
                        key={subPhase.id}
                        onClick={() => setActiveSubPhaseId(subPhase.id)}
                        className={`workflow-subphase-item ${isActiveSub ? 'active' : ''}`}
                      >
                        <div className="workflow-subphase-item-left">
                          <div className={`workflow-subphase-icon ${iconStatusClass}`}>
                            {idxStr}
                          </div>
                          <span className={`workflow-subphase-name ${isActiveSub ? 'active' : ''}`}>
                            {subPhase.name}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div 
                  className="drawer-toggle-btn"
                  onClick={() => setIsDrawerOpen(false)}
                >
                  <img src={WorkflowsCloseDrawerIcon} alt="Close Sidebar" style={{ width: "24px", height: "24px" }} />
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center pt-2 position-relative" style={{ flex: "0 0 50px", width: "50px", minHeight: "400px" }}>
                <div 
                  className="drawer-toggle-btn"
                  onClick={() => setIsDrawerOpen(true)}
                >
                  <img src={WorkflowsOpenDrawerIcon} alt="Open Sidebar" style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            )}

            <div 
              style={{ flex: "1", minWidth: 0, overflowX: "auto" }} 
              className={`pl-3 ${isDrawerOpen ? "border-left" : "ml-4"}`}
            >
              <ReactTable
                data={filteredTasks}
                columns={gridColumns}
                className="-striped -highlight"
                getTheadProps={() => ({
                  style: {
                    overflowY: "hidden",
                    background: "#B1FA63",
                    color: "#243837",
                  },
                })}
                defaultPageSize={5}
                showPagination={true} 
                noDataText="No data available"
              />
            </div>
          </div>
        ) : (
          <Col md={12} className="pb-4 pt-3 p-0">
            {masterPhaseTabs.map((masterTab) => {
              const masterId = String(masterTab.id);
              const rawName = masterTab.name || masterTab.phase || masterTab.masterPhase || masterTab.phaseName || `PHASE ${masterId}`;
              const displayMasterName = String(rawName).toUpperCase();

              if (!masterPhasesMap[masterId] || masterPhasesMap[masterId].length === 0) return null;

              const hasTasksInMasterPhase = masterPhasesMap[masterId].some(wp =>
                filteredTasks.some(task => Number(task.WorkflowPhases) === Number(wp.id))
              );

              if (!hasTasksInMasterPhase) return null;

              return (
                <div key={masterId} className="mb-4">
                  <h6 className="mb-3" style={{  borderBottom: "1px solid #e9ecef", paddingBottom: "5px" }}>
                    <b>{displayMasterName}</b>
                  </h6>

                  {renderPreviewSubPhases(masterId)}
                </div>
              );
            })}
          </Col>
        )}
      </Card>
    </>
  );
}

export default WorkflowUpdatedPhaseSettings;